<section class="page-surface p-6 lg:p-8" [formGroup]="group">
  <h2 class="text-lg font-semibold text-slate-700 underline underline-offset-4">
    Bank Account Details
  </h2>

  <div class="mt-5 rounded-2xl border border-slate-200 bg-white p-5 lg:p-6">
    <div class="grid gap-5">
      <div class="page-control-group">
        <label class="page-label" for="accountNumber"
          >Account Number <span class="ml-1 text-red-500">*</span></label
        >
        <input
          [appCharLength]="10"
          id="accountNumber"
          class="page-control"
          type="text"
          placeholder="e.g. 104268290"
          formControlName="accountNumber"
          [class.border-red-300]="hasError('accountNumber')"
        />
        <small *ngIf="hasError('accountNumber')" class="text-xs text-red-500"
          >Account number must be 10 digits.</small
        >
      </div>

      <div class="page-control-group">
        <label class="page-label" for="bank">Bank <span class="ml-1 text-red-500">*</span></label>
        <div class="relative">
          <button
            id="bank"
            type="button"
            class="page-select w-full flex items-center justify-between"
            [class.border-red-300]="hasError('bank')"
            aria-haspopup="listbox"
            [attr.aria-expanded]="open"
            (click)="toggle()"
          >
            <span class="truncate">{{ selectedBankName || '-- Select Bank --' }}</span>
            <span class="ml-3 text-slate-400">▼</span>
          </button>

          <div
            *ngIf="open"
            class="absolute z-50 mt-2 w-full rounded-xl border border-slate-200 bg-white shadow-lg"
          >
            <div class="p-3 border-b border-slate-100">
              <input
                type="text"
                class="page-control w-full"
                placeholder="Type to search banks..."
                autocomplete="off"
                [(ngModel)]="term"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>

            <div role="listbox" class="p-2 overflow-auto" style="max-height: 260px;">
              <button
                *ngFor="let bank of filteredBanks"
                type="button"
                class="w-full text-left rounded-lg px-3 py-2 hover:bg-slate-50"
                (click)="selectBank(bank)"
              >
                {{ bank.name }}
              </button>

              <div *ngIf="filteredBanks.length === 0" class="px-3 py-4 text-sm text-slate-500">
                No matching banks found.
              </div>
            </div>
          </div>
        </div>
        <small *ngIf="hasError('bank')" class="text-xs text-red-500">Select a bank.</small>
      </div>

      <div class="page-control-group">
        <label class="page-label" for="accountName"
          >Account Name <span class="ml-1 text-red-500">*</span></label
        >
        <input
          id="accountName"
          class="page-control"
          type="text"
          placeholder="John Smith"
          formControlName="accountName"
        />
        <small *ngIf="hasError('bankVerified')" class="text-xs text-red-500"
          >Please verify bank details.</small
        >
      </div>
    </div>
  </div>
</section>
